module.exports = __webpack_public_path__ + "static/media/eb2079f4-b23a-42d8-a1ba-22593624a716.a39d1d3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/eb2079f4-b23a-42d8-a1ba-22593624a716.jpg
// module id = 861
// module chunks = 0